var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "filter-container-content", attrs: { id: "baseInfo" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 14 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "reqired",
                      attrs: { prop: "bkNo", label: _vm.$t("home.myTemplate") },
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" },
                        ],
                        attrs: {
                          maxlength: "20",
                          onblur: "this.value = this.value.toUpperCase()",
                        },
                        model: {
                          value: _vm.form.bkNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bkNo", $$v)
                          },
                          expression: "form.bkNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "createTime",
                        label: _vm.$t("home.createTime"),
                      },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm",
                          placeholder: "",
                          disabled: true,
                        },
                        model: {
                          value: _vm.form.createdDtmLoc,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "createdDtmLoc", $$v)
                          },
                          expression: "form.createdDtmLoc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 14 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "reqired",
                      attrs: {
                        prop: "transportationTerms",
                        label: _vm.$t("home.transportationTerms"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.form.transportationTerms,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "transportationTerms", $$v)
                            },
                            expression: "form.transportationTerms",
                          },
                        },
                        _vm._l(
                          _vm.transportationTermsList,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: String(item), value: item },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "reqired",
                      attrs: {
                        prop: "paidType",
                        label: _vm.$t("home.paidType"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.form.paidType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "paidType", $$v)
                            },
                            expression: "form.paidType",
                          },
                        },
                        _vm._l(_vm.paidTypeList, function (item) {
                          return _c("el-option", {
                            key: item.codeValue,
                            attrs: {
                              label:
                                _vm.language === "zh"
                                  ? item.displayValueCn
                                  : item.displayValue,
                              value: Number(item.codeValue),
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "agreementNo",
                        label: _vm.$t("home.agreementNo"),
                      },
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" },
                          { name: "trim", rawName: "v-trim" },
                          { name: "fth", rawName: "v-fth" },
                        ],
                        attrs: {
                          maxlength: "50",
                          onblur: "this.value = this.value.toUpperCase()",
                        },
                        model: {
                          value: _vm.form.agreementNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "agreementNo", $$v)
                          },
                          expression: "form.agreementNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "reqired",
                      attrs: { prop: "freeTimeNo", label: _vm.$t("home.ft") },
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" },
                          { name: "trim", rawName: "v-trim" },
                          { name: "fth", rawName: "v-fth" },
                        ],
                        attrs: {
                          maxlength: "50",
                          onblur: "this.value = this.value.toUpperCase()",
                        },
                        model: {
                          value: _vm.form.freeTimeNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "freeTimeNo", $$v)
                          },
                          expression: "form.freeTimeNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 14 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "reqired",
                      attrs: { prop: "por", label: _vm.$t("home.por") },
                    },
                    [
                      _c("glPort", {
                        on: { change: _vm.changePol },
                        model: {
                          value: _vm.form.por,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "por", $$v)
                          },
                          expression: "form.por",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "reqired",
                      attrs: { prop: "pol", label: _vm.$t("home.pol") },
                    },
                    [
                      _c("glPort", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.pol,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "pol", $$v)
                          },
                          expression: "form.pol",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "reqired",
                      attrs: { prop: "pod", label: _vm.$t("home.pod") },
                    },
                    [
                      _c("glPort", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.pod,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "pod", $$v)
                          },
                          expression: "form.pod",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "reqired",
                      attrs: { prop: "del", label: _vm.$t("home.del") },
                    },
                    [
                      _c("glPort", {
                        on: { change: _vm.changeDel },
                        model: {
                          value: _vm.form.del,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "del", $$v)
                          },
                          expression: "form.del",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 14 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "reqired", attrs: { prop: "porName" } },
                    [
                      _c("glPort", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.porName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "porName", $$v)
                          },
                          expression: "form.porName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "reqired", attrs: { prop: "polName" } },
                    [
                      _c("glPort", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.polName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "polName", $$v)
                          },
                          expression: "form.polName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "reqired", attrs: { prop: "podName" } },
                    [
                      _c("glPort", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.podName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "podName", $$v)
                          },
                          expression: "form.podName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "reqired", attrs: { prop: "delName" } },
                    [
                      _c("glPort", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.delName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "delName", $$v)
                          },
                          expression: "form.delName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("sailSchedule", {
        ref: "sailSchedule",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.sailScheduleDialogVisible,
        },
        on: {
          selectionChange: _vm.selectionChange,
          "update:visible": function ($event) {
            _vm.sailScheduleDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }